const MiniCK = (CKEDITOR) => {
    return {
        width: '100%',
        extraPlugins: 'font,justify,lineheight',
        toolbarGroups: [
            { name: 'basicstyles', groups: ['basicstyles', 'cleanup'] },
            { name: 'styles', groups: ['styles'] },
            { name: 'clipboard', groups: ['undo'] },
            { name: 'editing', groups: ['find', 'selection', 'spellchecker', 'editing'] },
            { name: 'paragraph', groups: ['list', 'blocks', 'align', 'bidi', 'paragraph'] },
            { name: 'links', groups: ['links'] },
            { name: 'insert', groups: ['insert'] },
        ],
        removeButtons: 'Subscript,Superscript,Image,Table,Cut,Copy,Paste,PasteText,PasteFromWord,Scayt,Anchor,HorizontalRule,SpecialChar,Strike,RemoveFormat,Outdent,Indent,Blockquote,Styles,About,Font,Format',
        allowedContent: true,
        startupShowBorders: false,
        enterMode: CKEDITOR.ENTER_P,
        shiftEnterMode: CKEDITOR.ENTER_BR
    }
};

const SmallCK = (CKEDITOR) => {
    return {
        width: '100%',
        extraPlugins: 'strinsert,font,justify,lineheight,colorbutton',
        toolbarGroups: [
            { name: 'basicstyles', groups: ['basicstyles', 'cleanup'] },
            { name: 'styles', groups: ['styles'] },
            { name: 'editing', groups: ['find', 'selection', 'spellchecker', 'editing'] },
            { name: 'paragraph', groups: ['list', 'blocks', 'align', 'bidi', 'paragraph'] },
            { name: 'links', groups: ['links'] },
            { name: 'insert', groups: ['insert'] },
            { name: 'others', groups: ['others'] }
        ],
        removeButtons: 'Subscript,Superscript,Image,Table,Cut,Copy,Paste,PasteText,PasteFromWord,Scayt,Anchor,HorizontalRule,SpecialChar,Strike,RemoveFormat,Outdent,Indent,Blockquote,Styles,About,Font,Format',
        allowedContent: true,
        startupShowBorders: false,
        enterMode: CKEDITOR.ENTER_P,
        shiftEnterMode: CKEDITOR.ENTER_BR
    }    
};

const MaxCK = (CKEDITOR) => {
    return {
        width: '100%',
        height: '50vh',
        extraPlugins: 'font,justify,lineheight,colorbutton',
        toolbarGroups: [
            { name: 'basicstyles', groups: ['basicstyles', 'cleanup'] },
            { name: 'styles', groups: ['styles'] },
            { name: 'clipboard', groups: ['undo'] },
            { name: 'editing', groups: ['find', 'selection', 'spellchecker', 'editing'] },
            { name: 'paragraph', groups: ['list', 'blocks', 'align', 'bidi', 'paragraph'] },
            { name: 'links', groups: ['links'] },
            { name: 'insert', groups: ['insert'] },
            { name: 'forms', groups: ['forms'] },
            { name: 'styles', groups: ['styles'] },
            { name: 'colors', groups: ['colors'] },
            { name: 'tools', groups: ['tools'] },
            { name: 'about', groups: ['about'] },
            { name: 'others', groups: ['others'] }
        ],
        removeButtons: 'Image,Table,PasteFromWord,Scayt,Anchor, Styles,About,Font',
        allowedContent: true,
        startupShowBorders: false,
        enterMode: CKEDITOR.ENTER_P,
        shiftEnterMode: CKEDITOR.ENTER_BR
    }    
};


const BigCK = (CKEDITOR) => {
    return {
        width: '645px',
        height: '125vh',
        resize_enabled: false,
        extraPlugins: 'dialog,dialogui,colorbutton,font,strinsert,justify',
        toolbarGroups: [
            { name: 'basicstyles', groups: ['basicstyles', 'cleanup'] },
            { name: 'clipboard', groups: ['clipboard', 'undo'] },
            { name: 'editing', groups: ['find', 'selection', 'spellchecker', 'editing'] },
            { name: 'paragraph', groups: ['list', 'indent', 'blocks', 'align', 'bidi', 'paragraph'] },
            { name: 'links', groups: ['links'] },
            { name: 'insert', groups: ['insert'] },
            { name: 'others', groups: ['others'] },
            '/',
            { name: 'forms', groups: ['forms'] },
            { name: 'styles', groups: ['styles'] },
            { name: 'colors', groups: ['colors'] },
            { name: 'tools', groups: ['tools'] },
            { name: 'about', groups: ['about'] }
        ],
        removeButtons: 'Underline,Subscript,Superscript,PasteText,PasteFromWord,Scayt,Anchor,HorizontalRule,SpecialChar,Strike,RemoveFormat,Outdent,Indent,Blockquote,Styles,About',
        allowedContent: true,
        fullPage: true,
        startupShowBorders: false,
        enterMode: CKEDITOR.ENTER_P,
        shiftEnterMode: CKEDITOR.ENTER_BR,
        removePlugins: 'resize', // Optional: Remove the resize plugin to prevent manual resizing of the editor
  
    }    
};

const AdminCK = (CKEDITOR) => {
    return {
        width: '100%',
        height: '50vh',
        resize_enabled: false,
        extraPlugins: 'dialog,dialogui,colorbutton,font,strinsert,justify',
        toolbarGroups: [
            { name: 'basicstyles', groups: ['basicstyles', 'cleanup'] },
            { name: 'clipboard', groups: ['clipboard', 'undo'] },
            { name: 'editing', groups: ['find', 'selection', 'spellchecker', 'editing'] },
            { name: 'paragraph', groups: ['list', 'indent', 'blocks', 'align', 'bidi', 'paragraph'] },
            { name: 'links', groups: ['links'] },
            { name: 'insert', groups: ['insert'] },
            { name: 'others', groups: ['others'] },
            { name: 'forms', groups: ['forms'] },
            { name: 'styles', groups: ['styles'] },
            { name: 'colors', groups: ['colors'] },
            { name: 'tools', groups: ['tools'] },
            { name: 'about', groups: ['about'] }
        ],
        removeButtons: 'Underline,Subscript,Superscript,PasteText,PasteFromWord,Scayt,Anchor,HorizontalRule,SpecialChar,Strike,RemoveFormat,Outdent,Indent,Blockquote,Styles,About',
        allowedContent: true,
        fullPage: true,
        startupShowBorders: false,
        enterMode: CKEDITOR.ENTER_P,
        shiftEnterMode: CKEDITOR.ENTER_BR,
        removePlugins: 'resize', // Optional: Remove the resize plugin to prevent manual resizing of the editor
  
    }    
};


export {
    MiniCK,
    SmallCK,
    BigCK,
    MaxCK,
    AdminCK
};

